export default function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}



// WEBPACK FOOTER //
// ./src/app/utils/checkStatus.js